import * as React from 'react';
import * as Markdown from 'react-markdown';
import LegalLayout from '../Layouts/LegalLayout';
import { lifecycle } from 'recompose';

type Props = {
  input: any;
};

const Terms: React.SFC<Props> = ({ input }) => (
  <LegalLayout>
    <Markdown source={input} />
  </LegalLayout>
);

export default lifecycle({
  async componentDidMount() {
    const markdown = require('../../markdown/terms.md');
    const result = await fetch(markdown);
    const input = await result.text();
    this.setState({ input });
  },
})(Terms);



// WEBPACK FOOTER //
// ./src/containers/Pages/Terms.tsx